










import Vue from 'vue';
import Bidding from '../../components/detail/Bidding.vue'

export default Vue.extend({
  name: 'BiddingLog',
  props: [
    'biddingLog',
  ],
  components: {
    Bidding,
  }
});
